import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/trade-lookup")({
  staticData: { breadcrumb: "Trade Lookup" },
});
